<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableDataVue = {};
export default {
  name: "TableVpcResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      companyId: "",
      accountName: "",
      name: "",
      columns: [
        {
          title: this.$t("RAM.AWS.ElasticCache.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.computeInstance.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.ALI.Vpc.name"),
          key: "name"
        },
        {
          title: this.$t("RAM.ALI.Vpc.id"),
          key: "vpcId"
        },
        {
          title: this.$t("RAM.ALI.Vpc.Cidr"),
          key: "vpcCidr"
        },
        {
          title: this.$t("RAM.ALI.Vpc.region"),
          key: "region"
        },
        {
          title: this.$t("RAM.ALI.Vpc.defaultVpc"),
          key: "defaultVpc"
        },
        {
          title: this.$t("RAM.ALI.Vpc.stateName"),
          key: "stateName"
        }
      ],
      tableData: []
    };
  },
  beforeCreate: function() {
    tableDataVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("companyId", function(companyId) {
      tableDataVue.companyId = companyId;
    });
    eventBus.$on("accountName", function(accountName) {
      tableDataVue.accountName = accountName;
    });
    eventBus.$on("name", function(name) {
      tableDataVue.name = name;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableDataVue.getData();
    },
    //分页显示数据
    /****************************************************/
    getData: function() {
      this.$api.resourceManagement
        .selectAliVpcByPage({
          pageNum: this.current,
          pageSize: this.pageSize,
          companyId: tableDataVue.companyId,
          accountName: tableDataVue.accountName,
          accountType: 1,
          name: tableDataVue.name
        })
        .then(res => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableDataVue.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableDataVue.getData();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/vpc/TableVpcResource.vue